import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates message for mobile rendering section
 * @param {Object} data - The mobile rendering data object
 * @returns {string|null} - Message for empty state or null if data exists
 */
const generateMessage = (data) => {
  const hasPhone = data?.phone;
  const hasTablet = data?.tablet;

  if (!hasPhone && !hasTablet) {
    return 'The Mobile Rendering was not able to be generated.';
  }
  return null;
};

/**
 * Transforms the mobile_rendering criteria from WooRank API response
 * @param {Object} mobileRenderingCriteria - The mobile_rendering criteria object from the API
 * @returns {Object} - Transformed mobile rendering data for React components
 */
export const transformMobileRendering = (mobileRenderingCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!mobileRenderingCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'The Mobile Rendering was not able to be generated.',
      data: null,
    };
  }

  const data = mobileRenderingCriteria?.data || {};
  const wooRankStatus = mobileRenderingCriteria?.status || 'neutral';
  const importance = mobileRenderingCriteria?.importance || 0;
  const solvability = mobileRenderingCriteria?.solvability || 0;

  const phone = data?.phone || null;
  const tablet = data?.tablet || null;
  const desktop = data?.desktop || null;

  const hasScreenshots = phone || tablet;
  const isEmpty = !hasScreenshots;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(data),
    data: isEmpty ? null : {
      phone,
      tablet,
      desktop,
    },
  };
};

export default transformMobileRendering;

